import { RequestStatus } from '@/pages/avatar/common/types';
import { when } from 'mobx';
import { saveExpressDraftAvatar } from '../../api';
import createAvatarStore from '../../CreateAvatarStore';

export const saveDraftAvatar = async () => {
    if (createAvatarStore.footageFile && createAvatarStore.footageUploadStatus === RequestStatus.IDLE) {
        await createAvatarStore.handleFootage();
    }

    // Wait for the footage to upload before save the draft
    await when(() => createAvatarStore.footageUploadStatus !== RequestStatus.LOADING);

    // If the consent is not uploaded, clear the uploaded consent ID to avoid sending it to the API
    if (createAvatarStore.consentValidationStatus === RequestStatus.LOADING) {
        createAvatarStore.setUploadedConsentId('');
    }

    return await saveExpressDraftAvatar(createAvatarStore.payload);
};
